import { List } from 'immutable';
import { BasicColumnTypes, IOgqlSemanticType, SemanticTypes } from '@opengov/ogql-types';

// the possible column types for amounts
export enum AmountType {
  Currency = 'currency',
  Percent = 'percentage',
  Numeric = 'numeric'
}

export const amountTypeValues = (Object as any).values(AmountType);

export const AmountTypeCharacter = {
  [AmountType.Numeric]: '#',
  [AmountType.Percent]: '%',
  [AmountType.Currency]: '$'
};

// turn a number into a 3 number character string
export const digitRemover = (nmbr: number): string => {
  const s = nmbr.toString();
  if (s.length < 3) return s;
  let numberString = '';
  let numbersFound = 0;
  for (let i = 0; numbersFound < 3 && i < s.length; i++) {
    numberString += s[i];
    if (s[i] !== '.') numbersFound++;
  }
  if (numbersFound < 2) {
    numberString += '0';
  }
  return numberString;
};

export const abbreviateNumber = (nmbr: number): string => {
  const absoluteValue = Math.abs(nmbr);

  if (absoluteValue <= 999) return `${digitRemover(absoluteValue)}`;
  if (absoluteValue <= 999999) return `${digitRemover(absoluteValue / 1000)}k`;
  if (absoluteValue <= 999999999) return `${digitRemover(absoluteValue / 1000000)}M`;
  if (absoluteValue <= 999999999999) return `${digitRemover(absoluteValue / 1000000000)}B`;
  if (absoluteValue <= 999999999999999) return `${digitRemover(absoluteValue / 1000000000000)}T`;
  // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
  if (absoluteValue <= 999999999999999999) return `${digitRemover(absoluteValue / 1000000000000000)}Q`;
};

export const calculateColumnAmountType = (column) => {
  if (column.type === BasicColumnTypes.Numeric) {
    let semanticTypes: List<string> | List<IOgqlSemanticType>;
    semanticTypes = column.semanticTypes;
    if (Array.isArray(column.semanticTypes)) {
      semanticTypes = List(column.semanticTypes) as List<string> | List<IOgqlSemanticType>;
    }
    if (semanticTypes) {
      if (semanticTypes.first && typeof semanticTypes.first() === 'string') {
        if (semanticTypes.find((type) => type === SemanticTypes.StructuredDataType.MonetaryAmount || type === SemanticTypes.StructuredDataType.MonetaryAmountHttps))
          return AmountType.Currency;
      } else {
        if (semanticTypes.find((t) => t.type && t.type.includes(AmountType.Percent))) return AmountType.Percent;
        if (semanticTypes.find((t) => t.type && t.type.includes(AmountType.Currency))) return AmountType.Currency;
      }
    }
    return AmountType.Numeric;
  }
  if (column.type === BasicColumnTypes.DayInterval || column.type === BasicColumnTypes.YearInterval) {
    return AmountType.Numeric;
  }
  return column.type;
};

const sign = (nmbr: number) => (nmbr < 0 ? '-' : '');

export const amountTypes = {
  [AmountType.Currency]: {
    formatter: (nmbr) => `${sign(nmbr)}${AmountTypeCharacter[AmountType.Currency]}${abbreviateNumber(nmbr)}`,
    size: 50
  },
  [AmountType.Percent]: {
    formatter: (nmbr) => `${sign(nmbr)}${abbreviateNumber(nmbr * 100)}${AmountTypeCharacter[AmountType.Percent]}`,
    size: 50
  },
  [AmountType.Numeric]: {
    formatter: (nmbr) => `${sign(nmbr)}${abbreviateNumber(nmbr)}`,
    size: 50
  }
};
